import styled from "styled-components";
import { mq } from "../../styles/canonical/breakpoints";
import { kpiFaixaCss, kpiTileCss } from "../../components/ListaCompacta/styles";
import {
  WeekdayRow as CalWeekdayRow,
  MonthGrid as CalMonthGrid,
  WeekGrid as CalWeekGrid,
  MiniWeekdayRow as CalMiniWeekdayRow,
  MiniDaysGrid as CalMiniDaysGrid,
  WeekdayCell as CalWeekdayCell,
  FeriadoChip as CalFeriadoChip,
  EventPill as CalEventPill,
  MoreLink as CalMoreLink,
  GrupoClienteNome as CalGrupoClienteNome,
  GrupoClienteCont as CalGrupoClienteCont,
  AmbienteItem as CalAmbienteItem,
  WeekWeekdayLabel as CalWeekWeekdayLabel,
  DayPanelWeekday as CalDayPanelWeekday,
  DayHojeBadge as CalDayHojeBadge,
  DiaGrupoNome as CalDiaGrupoNome,
  DayCardPill as CalDayCardPill,
  MiniWeekdayCell as CalMiniWeekdayCell,
  MiniDay as CalMiniDay,
  DayCardText as CalDayCardText,
} from "../../components/Calendar/styles";
import {
  PageContainer,
  PageState as SharedPageState,
  PageTitle,
  PageTopBar,
  getToneTokens,
} from "../../styles/shared";

export const Wrapper = styled(PageContainer)`
  gap: 16px;
  max-width: 1400px;
`;

export const PageState = styled(SharedPageState)``;

export const TopBar = styled(PageTopBar)`
  align-items: center;
`;

export const Title = styled(PageTitle)`
  font-weight: 600;
`;

export const TopBarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  min-width: 0;

  @media ${mq.tablet} {
    flex-wrap: nowrap;
    width: 100%;
  }
`;

export const ViewSwitcher = styled.div`
  display: inline-flex;
  align-items: stretch;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  overflow: hidden;
  background: ${({ theme }) => theme.surface};
`;

export const ViewToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  min-height: 36px;
  padding: 0 10px;
  border: 0;
  background: ${({ theme, $active }) => ($active ? theme.surfaceAlt : "transparent")};
  color: ${({ theme, $active }) => ($active ? theme.textPrimary : theme.textSecondary)};
  cursor: pointer;
  font: inherit;

  & + & {
    border-left: 1px solid ${({ theme }) => theme.border};
  }

  &:hover {
    background: ${({ theme }) => theme.surfaceAlt};
    color: ${({ theme }) => theme.textPrimary};
  }

  &[aria-pressed="true"] {
    color: ${({ theme }) => theme.accent};
  }
`;

export const SemPrazoSection = styled.section`
  border: 1px dashed ${({ theme }) => theme.border};
  border-radius: 8px;
  background: ${({ theme }) => theme.surface};
`;

export const SemPrazoHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 14px;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.textPrimary};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px;
  text-align: left;

  &:hover {
    background: ${({ theme }) => theme.surfaceAlt};
  }

  span.chevron {
    color: ${({ theme }) => theme.textSecondary};
    font-size: 13px;
    transition: transform 0.18s ease;
    transform: rotate(${({ $open }) => ($open ? "180deg" : "0deg")});
    display: inline-flex;
  }
`;

export const SemPrazoList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 6px;
  padding: 4px 12px 12px;

  @media ${mq.tablet} {
    display: block;
    padding: 4px 10px 10px;
  }
`;

export const DeliveryMeta = styled.div`
  margin-top: 4px;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;
`;

/* Subtítulo abaixo do título (mockup): "Ambientes com lote gerado e ainda
   sem entrega realizada". */
export const Subtitle = styled.div`
  margin-top: 3px;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;

  @media ${mq.tablet} {
    display: none;
  }
`;

/* Linha de controles do mockup: pills (esquerda) + view tabs (direita). */
export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;

  @media ${mq.tablet} {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`;

/* View tabs: Lista / Dia / Semana / Mês / Ano. Texto simples; ativo ganha
   fundo suave + cor accent (mockup). */
export const ViewTabs = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;

  @media ${mq.tablet} {
    display: flex;
    overflow-x: auto;
    scrollbar-width: none;
    white-space: nowrap;
    &::-webkit-scrollbar { display: none; }
  }
`;

export const ViewTab = styled.button`
  min-height: 32px;
  padding: 6px 12px;
  border: 0;
  border-radius: 8px;
  background: ${({ theme, $active }) => ($active ? theme.surfaceAlt : "transparent")};
  color: ${({ theme, $active }) => ($active ? theme.textPrimary : theme.textSecondary)};
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  cursor: pointer;
  transition: background 0.14s ease, color 0.14s ease;

  &:hover {
    color: ${({ theme }) => theme.textPrimary};
    background: ${({ theme }) => theme.surfaceAlt};
  }

  @media ${mq.tablet} {
    flex: 0 0 auto;
    min-height: 36px;
  }
`;

/* Lado direito da linha de controles: view tabs + seletor do calendário. */
export const ControlsRight = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  @media ${mq.tablet} {
    flex-wrap: nowrap;
    min-width: 0;
    justify-content: space-between;
  }
`;

/* Seletor "Previsões sem lote" (só no calendário): pill no mesmo desenho
   dos filtros de visão, com checkbox nativo na cor de accent e o contador
   do que entra no calendário. */
export const PrevisaoToggle = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  padding: 0 10px 0 9px;
  border-radius: 999px;
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? "color-mix(in srgb, var(--accent) 32%, transparent)" : theme.border};
  background: ${({ $active }) => ($active ? "var(--accent-soft)" : "transparent")};
  color: ${({ theme, $active }) => ($active ? "var(--accent)" : theme.textSecondary)};
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  transition: background 0.14s ease, color 0.14s ease, border-color 0.14s ease;

  input {
    width: 14px;
    height: 14px;
    margin: 0;
    accent-color: var(--accent);
    cursor: pointer;
  }

  em {
    min-width: 22px;
    min-height: 20px;
    padding: 1px 6px;
    border-radius: 999px;
    font-size: 11px;
    font-style: normal;
    display: inline-grid;
    place-items: center;
    background: ${({ theme, $active }) =>
      $active ? "color-mix(in srgb, var(--accent) 16%, transparent)" : theme.surfaceAlt};
    color: ${({ theme, $active }) => ($active ? "var(--accent)" : theme.textSecondary)};
  }

  &:hover {
    color: ${({ theme, $active }) => ($active ? "var(--accent)" : theme.textPrimary)};
    border-color: color-mix(in srgb, var(--accent) 32%, transparent);
  }

  @media ${mq.tablet} {
    flex: 0 0 auto;
    min-height: 36px;
    font-size: var(--text-min, 12px);
    em { font-size: var(--text-min, 12px); }
  }
`;

/* Navegador de data do calendário (‹ Hoje ›) no nível da página. */
export const DateNav = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const DateNavButton = styled.button`
  min-width: 32px;
  min-height: 32px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.surfaceAlt};
    color: ${({ theme }) => theme.textPrimary};
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const SearchBox = styled.label`
  position: relative;
  width: clamp(220px, 25vw, 360px);
  flex: 0 1 360px;

  @media ${mq.tablet} {
    width: auto;
    flex: 1 1 auto;
    min-width: 0;
  }
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  color: ${({ theme }) => theme.textSecondary};
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  min-height: 40px;
  padding: 9px 12px 9px 36px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textPrimary};
  font: inherit;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.accent};
    background: ${({ theme }) => theme.surface};
  }
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media ${mq.tablet} {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    white-space: nowrap;
    margin: 0 -16px;
    padding: 0 16px;
    &::-webkit-scrollbar { display: none; }
  }
`;

export const TabButton = styled.button`
  min-height: 36px;
  padding: 7px 12px;
  border-radius: 999px;
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? "color-mix(in srgb, var(--accent) 32%, transparent)" : theme.border};
  background: ${({ $active }) => ($active ? "var(--accent-soft)" : "transparent")};
  color: ${({ theme, $active }) => ($active ? "var(--accent)" : theme.textSecondary)};
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  transition: background 0.14s ease, color 0.14s ease, border-color 0.14s ease;

  span {
    min-width: 22px;
    min-height: 20px;
    padding: 1px 6px;
    border-radius: 999px;
    background: ${({ theme, $active }) =>
      $active ? "color-mix(in srgb, var(--accent) 16%, transparent)" : theme.surfaceAlt};
    color: ${({ theme, $active }) => ($active ? "var(--accent)" : theme.textSecondary)};
    font-size: 11px;
    display: inline-grid;
    place-items: center;
  }

  &:hover {
    color: ${({ theme, $active }) => ($active ? "var(--accent)" : theme.textPrimary)};
    border-color: color-mix(in srgb, var(--accent) 32%, transparent);
  }

  @media ${mq.tablet} {
    flex: 0 0 auto;
    span { font-size: var(--text-min, 12px); }
  }
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 180px), 1fr));
  gap: 10px;
  ${kpiFaixaCss}
`;

export const SummaryCard = styled.div`
  ${({ theme, $tone = "default" }) => {
    const tokens = getToneTokens(theme, $tone);
    const bg =
      $tone === "default"
        ? `linear-gradient(155deg, ${theme.surfaceAlt}, ${theme.surface})`
        : tokens.background;
    return `
      background: ${bg};
      border: 1px solid ${tokens.border};
    `;
  }}

  border-radius: 8px;
  padding: 12px 14px;
  min-width: 0;
  /* Glass do mockup (sheen + blur). */
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(13px) saturate(1.3);
  -webkit-backdrop-filter: blur(13px) saturate(1.3);

  /* Export (html2canvas ignora blur): gradiente glass viraria duas faixas
     de cor no JPG/PNG — achata para superficie solida so na captura. */
  body[data-export-mode="true"] & {
    background: ${({ theme, $tone = "default" }) =>
      $tone === "default"
        ? theme.surfaceAlt
        : getToneTokens(theme, $tone).background};
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }

  ${kpiTileCss}
`;

export const SummaryLabel = styled.div.attrs({ className: "kpi-label" })`
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${({ theme }) => theme.textSecondary};
  margin-bottom: 4px;

  @media ${mq.tablet} {
    font-size: var(--text-min, 12px);
  }
`;

export const SummaryValue = styled.div.attrs({ className: "kpi-num" })`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.05;
  color: ${({ theme, $tone = "default" }) => getToneTokens(theme, $tone).text};
  overflow-wrap: anywhere;
`;

/* Topo do card KPI: ícone + label uppercase (mockup). */
export const SummaryHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;

  @media ${mq.tablet} {
    margin-bottom: 0;
    > div > svg { display: none; }
  }
`;

export const SummaryHeadLeft = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: ${({ theme, $tone = "default" }) =>
    $tone === "default" ? theme.textSecondary : getToneTokens(theme, $tone).text};

  svg {
    flex-shrink: 0;
    opacity: 0.85;
  }
`;

/* Linha valor + sublabel (mockup: "27 pendentes", "0 tudo em dia"). */
export const SummaryRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
`;

export const SummarySub = styled.span.attrs({ className: "kpi-sub" })`
  font-size: 12.5px;
  font-weight: 500;
  color: ${({ theme }) => theme.textSecondary};
`;

/* Pill verde "tudo em dia" quando Em atraso = 0. */
export const SummaryPill = styled.span.attrs({ className: "kpi-sub" })`
  ${({ theme, $tone = "success" }) => {
    const t = getToneTokens(theme, $tone);
    return `background:${t.background};border:1px solid ${t.border};color:${t.text};`;
  }}
  display: inline-flex;
  align-items: center;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;

  @media ${mq.tablet} {
    font-size: var(--text-min, 12px);
  }
`;

/* Botão olho no card Valor total. */
export const EyeToggle = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.textTertiary};
  cursor: pointer;
  padding: 0;

  &:hover {
    color: ${({ theme }) => theme.textPrimary};
  }

  @media ${mq.tablet} {
    min-width: 36px;
    min-height: 36px;
    margin: -10px -8px -10px 0;
  }
`;

/* ===== Caption + legenda acima da tabela ===== */
export const TableSection = styled.section`
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  background: ${({ theme }) => theme.surface};
  overflow: hidden;
`;

export const TableCaption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 13px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.border};

  @media ${mq.tablet} {
    padding: 10px 12px;
  }
`;

export const CaptionTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.textPrimary};
`;

export const CaptionSub = styled.div`
  margin-top: 1px;
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
`;

export const Legend = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
`;

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  color: ${({ theme }) => theme.textSecondary};

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $tone }) =>
      $tone === "danger"
        ? "var(--danger-text)"
        : $tone === "warning"
          ? "var(--warning-text)"
          : "var(--success-text)"};
  }

  @media ${mq.tablet} {
    font-size: var(--text-min, 12px);
  }
`;

/* ===== Células ricas da tabela (mockup) ===== */
/* Ambiente: barra vertical de tom + nome. */
export const AmbienteCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;

  &::before {
    content: "";
    flex-shrink: 0;
    width: 3px;
    align-self: stretch;
    min-height: 18px;
    border-radius: 2px;
    background: ${({ $tone }) =>
      $tone === "danger"
        ? "var(--danger-text)"
        : $tone === "warning"
          ? "var(--warning-text)"
          : $tone === "neutral"
            ? "var(--neutral-text)"
            : "var(--success-text)"};
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

/* Marceneiro: avatar (iniciais) + nome (+ regime como sublabel). */
export const MarceneiroCell = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const MarceneiroText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.15;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const MarceneiroSub = styled.span`
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textTertiary};

  @media ${mq.tablet} {
    font-size: var(--text-min, 12px);
  }
`;

export const RowAvatar = styled.span`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  background: var(--accent-soft);
  color: var(--accent);
  border: 1px solid color-mix(in srgb, var(--accent) 22%, transparent);

  @media ${mq.tablet} {
    font-size: var(--text-min, 12px);
  }
`;

export const SemMarceneiro = styled.span`
  font-size: 12px;
  color: ${({ theme }) => getToneTokens(theme, "warning").text};
  font-weight: 500;
`;

/**
 * Sem scroll vertical interno — toda a lista renderiza, scroll e do <body>.
 * O sticky do <Th> usa top: var(--app-header-height) para ficar visivel.
 */
export const TableWrapper = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  background: ${({ theme }) => theme.surface};
`;

export const Tabela = styled.table.attrs(({ $density }) => ({
  "data-density": $density === "compact" ? "compact" : undefined,
}))`
  width: 100%;
  min-width: 1120px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12px;

  thead {
    background: ${({ theme }) => theme.surfaceAlt};
  }

  tbody tr + tr td {
    border-top: 1px solid ${({ theme }) => theme.border};
  }

  tbody tr:hover {
    background: ${({ theme }) => theme.surfaceAlt};
  }

  tbody td:nth-child(1),
  tbody td:nth-child(2),
  tbody td:nth-child(3) {
    white-space: normal;
    min-width: 130px;
  }

  &[data-density="compact"] {
    font-size: 11px;

    @media ${mq.tablet} {
      font-size: var(--text-min, 12px);
    }
    table-layout: fixed;
    min-width: 0;

    tbody td:nth-child(1),
    tbody td:nth-child(2),
    tbody td:nth-child(3) {
      min-width: 0;
    }
  }
`;

export const Th = styled.th`
  /* Bugfix #13 (2026-05-29): sticky header amplo. */
  position: sticky;
  top: var(--app-header-height, 0px);
  z-index: 5;
  padding: 9px 10px;
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textSecondary};
  font-size: 11px;
  font-weight: 500;
  text-align: ${({ $right }) => ($right ? "right" : "left")};
  white-space: nowrap;
  box-shadow: inset 0 -1px 0 ${({ theme }) => theme.border};

  /* Ver PainelTabela/styles.jsx: a regua do cabecalho vira border na captura. */
  body[data-export-mode="true"] & {
    border-bottom: 1px solid ${({ theme }) => theme.border};
  }

  [data-density="compact"] & {
    padding: 6px 10px;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  @media ${mq.tablet} {
    &&, [data-density="compact"] & { font-size: var(--text-min, 12px); }
  }
`;

export const Td = styled.td`
  padding: 8px 10px;
  color: ${({ theme }) => theme.textPrimary};
  font-size: 12px;
  font-weight: 400;
  line-height: 1.35;
  text-align: ${({ $right }) => ($right ? "right" : "left")};
  vertical-align: middle;
  white-space: nowrap;

  [data-density="compact"] & {
    padding: 4px 10px;
    font-size: 11px;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.25;
  }

  @media ${mq.tablet} {
    &&, [data-density="compact"] & { font-size: var(--text-min, 12px); }
  }
`;

export const DeliveryList = styled.div`
  display: grid;
  gap: 8px;
`;

export const DeliveryRow = styled.article`
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  background: ${({ theme }) => theme.surface};
  padding: 9px 10px;
  display: grid;
  gap: 6px;
  min-width: 0;
`;

export const DeliveryPrimary = styled.div`
  display: grid;
  grid-template-columns: minmax(180px, 1.4fr) minmax(160px, 1.2fr) minmax(70px, 0.45fr) auto;
  align-items: center;
  gap: 10px;
  min-width: 0;

  @media ${mq.mobile} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const DeliverySecondary = styled.div`
  display: grid;
  grid-template-columns: minmax(140px, 1.15fr) repeat(5, minmax(92px, 0.8fr));
  align-items: center;
  gap: 10px;
  min-width: 0;

  @media ${mq.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const FieldGroup = styled.div`
  min-width: 0;
`;

export const FieldLabel = styled.div`
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textSecondary};
  line-height: 1.2;

  @media ${mq.tablet} {
    font-size: var(--text-min, 12px);
  }
`;

export const FieldValue = styled.div`
  margin-top: 2px;
  color: ${({ theme }) => theme.textPrimary};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  overflow-wrap: anywhere;
`;

export const StatusBadge = styled.span`
  ${({ theme, $tone = "default" }) => {
    const tokens = getToneTokens(theme, $tone);
    return `
      background: ${tokens.background};
      border: 1px solid ${tokens.border};
      color: ${tokens.text};
    `;
  }}

  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-height: 28px;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  white-space: normal;

  @media ${mq.tablet} {
    min-height: 22px;
    padding: 2px 8px;
    white-space: nowrap;
  }
`;

export const EmptyState = styled.div`
  border: 1px dashed ${({ theme }) => theme.border};
  border-radius: 8px;
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textSecondary};
  padding: 24px;
  text-align: center;
  font-size: 14px;
`;

export const ObsModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 80;
  background: rgba(10, 15, 25, 0.48);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const ObsModalCard = styled.div`
  width: min(640px, 96vw);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.22);
`;

export const ObsModalHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const ObsModalTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.textPrimary};
  line-height: 1.3;
`;

export const ObsModalCloseButton = styled.button`
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;

  &:hover {
    background: ${({ theme }) => theme.surfaceAlt};
    color: ${({ theme }) => theme.textPrimary};
  }
`;

export const ObsModalBody = styled.div`
  padding: 16px 18px 18px;
  font-size: 13px;
  color: ${({ theme }) => theme.textPrimary};
  line-height: 1.5;
  white-space: pre-wrap;
  overflow: auto;
`;

/* Item da lista "sem prazo" no desktop (antes era estilo inline no botão). */
export const SemPrazoItem = styled.button`
  text-align: left;
  border: 0;
  background: transparent;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  color: inherit;
`;

/* Calendário no celular/tablet: zero scroll lateral sem reescrever o
   componente — as grades de 7 colunas passam a encolher (minmax(0, 1fr)) e
   os textos miúdos sobem ao piso de 12px. */
export const CalendarioArea = styled.div`
  @media ${mq.tablet} {
    min-width: 0;
    max-width: 100%;
    overflow-x: hidden;

    ${CalWeekdayRow}, ${CalMonthGrid}, ${CalWeekGrid}, ${CalMiniWeekdayRow}, ${CalMiniDaysGrid} {
      grid-template-columns: repeat(7, minmax(0, 1fr));
    }
    ${CalWeekdayCell}, ${CalFeriadoChip}, ${CalEventPill}, ${CalMoreLink},
    ${CalGrupoClienteNome}, ${CalGrupoClienteCont}, ${CalAmbienteItem},
    ${CalWeekWeekdayLabel}, ${CalDayPanelWeekday}, ${CalDayHojeBadge},
    ${CalDiaGrupoNome}, ${CalDiaGrupoNome} .cont, ${CalDayCardText} span,
    ${CalDayCardPill}, ${CalMiniWeekdayCell}, ${CalMiniDay} {
      font-size: var(--text-min, 12px);
    }
    ${CalWeekdayCell}, ${CalWeekWeekdayLabel}, ${CalMiniWeekdayCell} {
      overflow: hidden;
      text-overflow: clip;
    }
  }
`;

/* FilterPanel compacto vira só ícone (36px) no celular/tablet. O botão fica
   em CompactPanel > Actions > button — fora do alcance do SoIcone, que só
   pega filho direto. O texto continua no DOM (nome acessível). */
export const FiltroSoIcone = styled.span`
  display: contents;

  @media ${mq.tablet} {
    > div > div:first-child > button {
      width: 36px;
      min-height: 36px;
      padding: 0;
      gap: 0;
      font-size: 0;
      border-radius: 9px;
      justify-content: center;
    }
  }
`;
